import ModerationVote from '@/modules/cms/modules/moderation/model/ModerationVote'
import {Module} from 'vuex';
import {RootState} from '@/store/types'
import mutations from '@/modules/cms/modules/moderation/store/mutations'
import actions from '@/modules/cms/modules/moderation/store/actions'

/**
 * Define el estado del sub-sistema de moderación del modulo CMS
 */
export interface ModerationState {
    /**
     * Voto de moderación actualmente visualizado por el usuario
     */
    currentVote: ModerationVote

    /**
     * Lista de votos de moderación actualmente mostrada al usuario
     */
    currentVoteList: ModerationVote[],

    /**
     * Indica si el usuario autorizado actualmente puede moderar contenido
     * crear y actualizar votos
     */
    currentUserCanModerate: boolean,

    /**
     * Indica si ya se ha obtenido el permiso para moderador desde la API
     */
    permissionFetched: boolean,
}

const module: Module<ModerationState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state: {
        currentVote: new ModerationVote(),
        currentVoteList: [],
        currentUserCanModerate: false,
        permissionFetched: false,
    },
}

export default module
